import React, { Component } from 'react';
import API from '../../../api/api';
import './list.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, Input, Modal, message, Select, Popconfirm, ConfigProvider, Alert, DatePicker } from 'antd';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
class ChatSensitiveWords extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        pagination: {
            hideOnSinglePage: false,
            showQuickJumper: false,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            position: 'bottom',
        },
        mainList: [
            // {
            //     userId: '1',
            //     rowId: '1',
            //     userName: '就啊纠结啊姐',
            //     userImage: "{\"picture\":\"http://s1.im-dangdang.com/20210220/29b89c70-8f5e-4ad0-b322-4dfe12764cb5.jpg\"}",
            //     registTime: "2021-03-11 20:36:44",
            //     nickName: '快看看',
            //     hitTime: '20',
            //     friendsNum: '25',
            //     groupNum: "30",
            //     messageNum: "40",
            //     isFreeze: 0
            // },
        ],
        columns: [
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '姓名',
                key: 'userName',
                render: (data) => {
                    return (
                        <div className="userName">
                            <span className='userImage' style={{ backgroundImage: `url(${data.userImage})` }}></span>
                            <span>{data.userName}</span>
                        </div>
                    )
                }
            },
            {
                title: '昵称',
                dataIndex: 'nickName',
                key: 'nickName',
            },
            {
                title: '注册时间',
                dataIndex: 'registTime',
                key: 'registTime',
            },
            {
                title: '触发次数',
                key: 'hitTime',
                render: (data) => (
                    <a onClick={this.goDetail.bind(this, data)}>{data.hitTime}</a>
                )
            },
            {
                title: '好友数量',
                dataIndex: 'friendsNum',
                key: 'friendsNum',
            },
            {
                title: '群聊数量',
                dataIndex: 'groupNum',
                key: 'groupNum',
            },
            {
                title: '单聊/群聊/留言发送次数',
                dataIndex: 'messageNum',
                key: 'messageNum',
            },
            {
                title: '时间',
                key: 'updateTime',
                render: (data) => (
                    <span>{this.format(data.updateTime)}</span>
                )
            },
            {
                title: '触发高级敏感词',
                key: 'isHigh',
                render: (data) => (
                    <span>{data.isHigh == 1 ? '是' : '否'}</span>
                )
            },
            {
                title: '操作',
                key: 'isFreeze',
                render: (data) => (
                    <div className="operateBtnBlock">
                        {
                            data.isFreeze == '1' ? (
                                <Popconfirm title="确定取消冻结吗？"
                                    onConfirm={this.deleteFuncOrDis.bind(this, data, 0)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'unFreezeBtn' + data.userId} type="primary" ghost className="deleteBtn">取消冻结</Button>
                                </Popconfirm>
                            ) : (
                                    <Popconfirm title="确定冻结该用户吗？"
                                        onConfirm={this.deleteFuncOrDis.bind(this, data, 1)}
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <Button key={'unFreezeBtn' + data.userId} type="primary" className="deleteBtn">冻结</Button>
                                    </Popconfirm>
                                )
                        }
                    </div>
                ),
            },
        ],

        swList: '', // 敏感词列表
        hswList: '',// 高级敏感词列表
        SWModal: {
            show: false,
            loading: false,
        },
        HSWModal: {
            show: false,
            loading: false,
        },
        searchCondition: {
            pageNum: 10,
            pageSize: 1,
            userId: '',
            isFreeze: '',
            startTime: '',
            endTime: '',
            minHit: '',
            maxHit: '',
            level: ''
        }


    }

    componentDidMount() {
        let pagination = window.sessionStorage.getItem('chatSensitiveWords_pagination');
        let searchCondition = window.sessionStorage.getItem('chatSensitiveWords_searchCondition');
        console.log('pagination', pagination)
        if (pagination && searchCondition) {
            this.setState({
                pagination: JSON.parse(pagination),
                searchCondition: JSON.parse(searchCondition),
            }, () => {
                this.getListData()
                this.swMessageSwList() // swMessageSwList
                this.swMessageSwList(1) // swMessageSwList
            })
            return
        }
        this.getListData('homePage')
        this.swMessageSwList() // swMessageSwList
        this.swMessageSwList(1) // swMessageSwList

    }

    componentDidUpdate() {

    }

    add0(m) { return m < 10 ? '0' + m : m }

    format(shijianchuo) {
        //shijianchuo是整数，否则要parseInt转换
        var time = new Date(shijianchuo * 1000);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y + '/' + this.add0(m) + '/' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm);
    }

    goDetail(item) {
        const { pagination, searchCondition } = this.state;
        window.sessionStorage.setItem('chatSensitiveWords_pagination', JSON.stringify(pagination))
        window.sessionStorage.setItem('chatSensitiveWords_searchCondition', JSON.stringify(searchCondition))
        console.log('item', item)
        this.props.history.push({ pathname: "/chatSensitiveWordsDetail", state: { userId: item.userId } })
    }


    async getListData(type) {
        let { pagination, searchCondition } = this.state;
        if ('homePage' == type) {
            searchCondition.pageSize = 1
            pagination.current = 1
        }
        let result = await API.swMessageMainList(searchCondition);
        if (result.status == 1) {
            let mainList = result.data.mainList;
            pagination.total = Number(result.data.totalNum);
            this.setState({
                pagination,
                mainList
            })
        }
    }

    async swMessageSwList(isHigh) {
        let result = await API.swMessageSwList({ isHigh });
        if (result.status == 1) {
            if (isHigh == 1) {
                let hswList = result.data.swList;
                this.setState({
                    hswList: hswList.toString()
                })
            } else {
                let swList = result.data.swList;
                this.setState({
                    swList: swList.toString()
                })
            }

        }
    }

    async deleteFuncOrDis(data, isFrozen) {
        let result = await API.swMessageFrozen({
            userId: data.userId,
            isFrozen
        })
        if (result.status == 1) {
            if(isFrozen == 1){
                message.success('冻结成功');
            }else{
                message.success('解冻成功');
            }
            this.getListData();
            return;
        }
        message.error(result.msg);
    }

    handleTableChange = (pagination) => {
        let { searchCondition, mainList } = this.state;
        console.log('pagination.current', pagination.current)
        searchCondition.pageSize = pagination.current;
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
            searchCondition
        }, () => {
            this.getListData();
        });
    };

    onShowSizeChange = (current, pageSize) => {
        let { searchCondition, pagination } = this.state;
        pagination.pageSize = pageSize
        pagination.current = 1
        searchCondition.pageNum = pageSize;
        searchCondition.pageSize = 1;
        this.setState({
            pagination,
            searchCondition
        }, () => {
            this.getListData();
        });
    }

    handleAddModalCancel() {//添加或编辑对话框点击取消后
        let { SWModal, HSWModal } = this.state;
        SWModal.show = false;
        HSWModal.show = false;
        this.setState({ SWModal, HSWModal })
    }

    async accessOn(type) {
        let { swList, hswList, SWModal, HSWModal } = this.state;
        if (type == 0) {
            SWModal.loading = true
        }
        if (type == 1) {
            HSWModal.loading = true
        }
        this.setState({ SWModal, HSWModal });
        console.log('swList', swList, type);
        let result = await API.swMessageAdd({ swList: type == 1 ? hswList : swList, isHigh: type });
        if (type == 0) {
            SWModal.show = false;
            SWModal.loading = false;
        }
        if (type == 1) {
            HSWModal.show = false;
            HSWModal.loading = false;
        }
        this.setState({ SWModal, HSWModal })
        if (result.status == 1) {
            message.success('保存成功')
            this.getListData('homePage');
            return;
        }
        message.error(result.msg)
    }



    showModal = (type) => {
        let { SWModal, HSWModal } = this.state;
        if (type == 1) {
            SWModal.show = true;
        }
        if (type == 2) {
            HSWModal.show = true;
        }
        this.setState({ SWModal, HSWModal })
    }

    TextAreaOnChange(e, swList) {
        console.log('swList',swList)
        if (swList == 'swList') {
            this.setState({ swList: e.target.value })
        }
        if (swList == 'hswList') {
            this.setState({ hswList: e.target.value })
        }
    }

    InputItemChange(target, e) {
        let value = e.target.value.trim();
        let { searchCondition } = this.state;
        searchCondition[target] = value
        console.log('searchCondition', searchCondition)
        this.setState({ searchCondition })
    }

    onSelectChange(key,value ) {//下拉框更改
        console.log(value, key)
        let { searchCondition } = this.state;
        searchCondition[key] = value;
        console.log('searchCondition', searchCondition)
        this.setState({ searchCondition });
    }

    onSearchDateChange = (date) => { //筛选条件 ：时间范围
        let { searchCondition } = this.state;
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = '';
            endTime = '';
        } else {
            startTime = Math.floor(date[0].valueOf() / 1000);
            endTime = Math.floor(date[1].valueOf() / 1000);
        }
        searchCondition.startTime = startTime;
        searchCondition.endTime = endTime;
        console.log('searchCondition', searchCondition)
        this.setState({ searchCondition });
    }

    searchForData() {//搜索
        this.getListData('homePage');
    }

    render() {
        const {
            columns,
            mainList,
            pagination,
            SWModal,
            HSWModal,
            swList,
            hswList,
            searchCondition
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <div className={`chatSensitiveWords  `}>
                    <Button type="primary" className='sensitive-btn' onClick={() => this.showModal(1)}>敏感词管理</Button>
                    <Button type="primary" className='high-sensitive-btn' onClick={() => this.showModal(2)}>高级敏感词管理</Button>
                    <div className='search-model'>
                        <Input className='input-userId' value={searchCondition.userId} onChange={this.InputItemChange.bind(this, 'userId')} placeholder="用户ID搜索"></Input>
                        <RangePicker
                            size='Small'
                            className="rangePicker"
                            showTime={{ format: 'HH:mm:ss' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            onChange={this.onSearchDateChange.bind(this)}
                        ></RangePicker>
                        <Select className="selectBlock" value={searchCondition.isFreeze} onChange={this.onSelectChange.bind(this, 'isFreeze')}>
                            <Option value="">全部</Option>
                            <Option value="0">未冻结</Option>
                            <Option value="1">已冻结</Option>
                        </Select>
                        <Select className="selectBlock_" value={searchCondition.level} onChange={this.onSelectChange.bind(this, 'level')}>
                            <Option value="">全部</Option>
                            <Option value="2">高级敏感词</Option>
                            <Option value="1">普通敏感词</Option>
                        </Select>
                        <div className='range'>
                            <span className='searchname'>触发次数区间筛选</span>
                            <Input className='input-range' value={searchCondition.minHit} onChange={this.InputItemChange.bind(this, 'minHit')} placeholder=""></Input>-
                            <Input className='input-range' value={searchCondition.maxHit} onChange={this.InputItemChange.bind(this, 'maxHit')} placeholder=""></Input>
                        </div>
                        <Button type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
                    </div>
                    <Table columns={columns}
                        dataSource={mainList}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        onShowSizeChange={this.onShowSizeChange}
                        rowKey={(row, index) => row.userId + '-' + index}
                    />
                    <Modal
                        destroyOnClose={true}
                        title='敏感词'
                        onCancel={this.handleAddModalCancel.bind(this)}
                        visible={SWModal.show}
                        width={500}
                        footer={[
                            <Button key="back" onClick={this.handleAddModalCancel.bind(this)}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary" loading={SWModal.loading} onClick={this.accessOn.bind(this, 0)}>
                                保存
                            </Button>,
                        ]}
                    >
                        <div className="modalPane">
                            <TextArea rows={8} value={swList} allowClear onChange={(e) => this.TextAreaOnChange(e, 'swList')} />
                            <Alert className='alertError' message="输入敏感词以英文逗号隔开(eg: 佛教,佛学,佛光普照 )" type="error" />
                        </div>
                    </Modal>
                    <Modal
                        destroyOnClose={true}
                        title='高级敏感词'
                        onCancel={this.handleAddModalCancel.bind(this)}
                        visible={HSWModal.show}
                        width={500}
                        footer={[
                            <Button key="back" onClick={this.handleAddModalCancel.bind(this)}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary" loading={HSWModal.loading} onClick={this.accessOn.bind(this, 1)}>
                                保存
                            </Button>,
                        ]}
                    >
                        <div className="modalPane">
                            <TextArea rows={8} value={hswList} allowClear onChange={(e) => this.TextAreaOnChange(e, 'hswList')} />
                            <Alert className='alertError' message="输入高级敏感词以英文逗号隔开(eg: 佛教,佛学,佛光普照 )" type="error" />
                        </div>
                    </Modal>
                </div>
            </ConfigProvider>
        )
    }
}

export default ChatSensitiveWords;